<div class="flew-start g-space-xs align-center">
  @if (
    !this.conversationParticipant() ||
    (!this.conversationParticipant()?.user && !this.conversationParticipant()?.contact)
  ) {
    <cam-text size="sm" color="brand-primary">
      {{ this.email() || ('communication.participant.unknown' | translate) }}
    </cam-text>
  }
  @if (this.conversationParticipant()?.user; as user) {
    <cam-user-logo
      [userInfo]="{
        profilePictureUrl: user.picture,
        naming: {
          firstName: user.firstName,
          name: user.lastName,
          trigram: user.trigram,
        },
      }"
      size="md"
    ></cam-user-logo>

    <cam-text size="sm" color="brand-primary">
      {{
        fullName({
          firstName: user.firstName,
          name: user.lastName,
        })
      }}
      @if (this.email()) {
        <{{ this.email() }}>
      }
    </cam-text>
  }
  @if (this.conversationParticipant()?.contact; as contact) {
    <cam-text size="sm" color="brand-primary">
      {{
        fullName({
          firstName: contact.firstName,
          name: contact.lastName,
        })
      }}
      @if (this.email()) {
        <{{ this.email() }}>
      }
    </cam-text>
  }
</div>
